import { useAuthStore } from '~/stores/auth'

export const useAdmin = () => useAuthStore().isAdmin
